import { RouteType } from '@/lib/route';
import ThemeSetupComponent from '.';

const SettingsThemeSelectedRoutes: RouteType = {
  path: '/settings/theme/:themeId',
  component: ThemeSetupComponent,
};

export interface TenantSettingsThemeParamTypes {
  themeId: string;
}

export default SettingsThemeSelectedRoutes;
